// extracted by mini-css-extract-plugin
export var anchorDestination = "serializers-module--anchorDestination--55f7e";
export var bannerBlog = "serializers-module--bannerBlog--f9795";
export var blockQuote = "serializers-module--blockQuote--19371";
export var callout = "serializers-module--callout--365fc";
export var instagramEmbedContainer = "serializers-module--instagramEmbedContainer--32197";
export var quoteFeatured = "serializers-module--quoteFeatured--9ef48";
export var quoteText = "serializers-module--quoteText--ba969";
export var reactPlayerContainer = "serializers-module--reactPlayerContainer--3982a";
export var tip = "serializers-module--tip--abb83";
export var videoEmbed = "serializers-module--videoEmbed--78f78";